import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Productivity() {
  return <PlatformPage feature={platformFeatures['productivity']!} />
}
